<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px"
  [@routeAnimation]="true">
  <!-- Add screen content here -->
  <!-- <div class="cc-forms-container"> -->
  <div class="cc-form-loading-shade" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div>
  <div fxLayout="column">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>
  </div>
  <div fxLayout="column" class="mat-elevation-z8 table-container">
    <mat-table #table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="requestNo">
        <mat-header-cell style="flex-grow: 1.5;" *matHeaderCellDef mat-sort-header> Request No </mat-header-cell>
        <mat-cell style="flex-grow: 1.5;" *matCellDef="let row"> {{row.requestNo}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="formCCName">
        <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Request Name </mat-header-cell>
        <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.formCCName}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="OrgInfo.name">
        <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Organization Name </mat-header-cell>
        <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.OrgInfo.name}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="OrgInfo.subsection">
        <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Tax-Exempt Status </mat-header-cell>
        <mat-cell style="flex-grow: 2; text-align: center" *matCellDef="let row">
          {{ getTaxExemptStatus(row.OrgInfo.subsection_501)}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="effdt">
        <mat-header-cell style="flex-grow: 1.5;" *matHeaderCellDef mat-sort-header>Request Date </mat-header-cell>
        <mat-cell style="flex-grow: 1.5;" *matCellDef="let row"> {{row.effdt | date: 'MM-dd-yyyy'}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="statusDescr">
        <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
        <mat-cell style="flex-grow: 2;" *matCellDef="let row" [ngClass]="getStatusClass(row.statusDescr)">
          {{row.statusDescr}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="FormCCLogInfo.empName">
        <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
        <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.FormCCLogInfo.empName}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="FormCCLogInfo.title">
        <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Title </mat-header-cell>
        <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.FormCCLogInfo.title}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="FormCCLogInfo.comment">
        <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Comment </mat-header-cell>
        <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.FormCCLogInfo.comment}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="print-view">
        <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header></mat-header-cell>
        <mat-cell style="flex-grow: 1; " *matCellDef="let row">
          <button mat-icon-button matTooltip="Save application as PDF" (click)="onPrint()">
            <mat-icon color="primary">save_alt</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)">
      </mat-row>
    </mat-table>
  </div>
  <div fxLayout="column">
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100, 125, 150, 175, 200]"></mat-paginator>
  </div>
</div>